import React, { useState } from "react";
import { Footer } from "../../components/footer";
import { Header } from "../../header";

const videos = [
  {
    name: 'алёна швец. – БОЮСЬ, НО ХОЧУ (премьера клипа)',
    link: "https://vkvideo.ru/video_ext.php?oid=-163226140&id=456240868",
    preview: "https://sun1-94.userapi.com/impg/kHnl8O1757FWBDjsB0KFmc-s0Vs06EA4OS6h9Q/K4EF5GrB3xI.jpg?quality=90&proxy=1&sign=5e180e7443253548a5051a061168f57a&c_uniq_tag=NfriHp6rlWS3ltm6hCGz6g1NyAxbEopOklmGI-nYhO0&type=video_thumb",
  },
  {
    name: 'алёна швец., Саша Мусор – СОЛНЫШКО',
    link: "https://vkvideo.ru/video_ext.php?oid=-163226140&id=456240838",
    preview: "https://i.mycdn.me/getVideoPreview?id=8546372749873&idx=0&type=39&tkn=kK_yKqKWgYg4fLwkTAjucWnDXRU&fn=vid_w",
  },
  {
    name: 'алёна швец. – ПОДКРОВАТНЫЙ МОНСТР',
    link: "https://vkvideo.ru/video_ext.php?oid=-163226140&id=456240799",
    preview: "https://i.mycdn.me/getVideoPreview?id=7795032525469&idx=7&type=39&tkn=uEUojj_0WOPqh0P63FzyGQqJv28&fn=vid_w",
  },
  {
    name: 'алёна швец. - А ВЫ С НЕЙ СНОВА? (премьера клипа)',
    link: "https://vkvideo.ru/video_ext.php?oid=-163226140&id=456240661",
    preview: "https://sun9-71.userapi.com/impg/L3VupTYhNfATI70BvaFMQCxdS7AFwrTrqHHKNA/leMJ8MXguBc.jpg?quality=90&proxy=1&sign=2afe3461b357ee7a0e934734581d969e&c_uniq_tag=GbzIqmkgSaTIDgLKk3ffPUHaUXO_1bssIOj96jBfEQA&type=video_thumb",
  },
  {
    name: "алёна швец. – КАПУЧИНО",
    link: "https://vk.com/video_ext.php?oid=-163226140&id=456240761",
    preview: "https://i.mycdn.me/getVideoPreview?id=7565582666417&idx=0&type=39&tkn=dUdgVMizRBmpR8MYFz7NdcT25Ws&fn=vid_w",
  },
  {
    name: "алёна швец. - РАНЫ",
    link: "https://vkvideo.ru/video_ext.php?oid=-163226140&id=456240733",
    preview: "https://i.mycdn.me/getVideoPreview?id=7453401418258&idx=0&type=39&tkn=jf-VcgLR1F6IrLfB8wJIyogEvJk&fn=vid_w",
  },
  {
    name: "алёна швец. - НЕПОСЛУШНАЯ",
    link: "https://vk.com/video_ext.php?oid=-163226140&id=456240703",
    preview: "https://i.mycdn.me/getVideoPreview?id=8018777344512&idx=7&type=39&tkn=IKFWqRmuSe_gyjpmZGNHMj6rr0o&fn=vid_w",
  },
  {
    name: "Алёна Швец - мальчик из Питера в Питере",
    link: "https://vk.com/video_ext.php?oid=-163226140&id=456240567",
    preview: "https://sun9-66.userapi.com/v3D1H-b9Sr4HbLx_Tv4UT6nhuFHlX1uLBQFSsQ/qWpxo6gNzW4.jpg",
  },
  {
    name: "АЛЁНА ШВЕЦ - LIVE КОНЦЕРТ 2023",
    link: "https://vkvideo.ru/video_ext.php?oid=-163226140&id=456240479",
    preview: "https://sun1-83.userapi.com/N9C-WNORPq31r3xIBMy_u-KUkijqVeJJVtuMLQ/ThGElKVXSFE.jpg",
  },
  {
    name: "алёна швец. - Спи",
    link: "https://vk.com/video_ext.php?oid=-163226140&id=456240406",
    preview: "https://sun1-55.userapi.com/FSRl7SSExLuAN_HEHzu2NKXik5pCMMLADb8LAw/ITbcMiDrKeY.jpg",
  },
  {
    name: "БЭКСТЕЙДЖ КЛИПА «ВЕЧНО 17»",
    link: "https://vk.com/video_ext.php?oid=-163226140&id=456240394",
    preview: "https://sun1-98.userapi.com/KOeccVeZdUpTXbTdV51RZed7YZgynR3DSm2hRw/p7c8sFFVNgI.jpg",
  },
];

export const VideosPage = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  document.title = "Видео | Сайт Алёны Швец";

  const openModal = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <section id="main" className="flex flex-col justify-center items-center w-full bg-sky-200 relative">
      <Header page="videos"
      fixed={false} />

      <div className="p-6 md:p-12 max-w-screen-2xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {videos.map((video, index) => (
            <div
              key={index}
              className="flex flex-col bg-white rounded-lg shadow-md cursor-pointer overflow-hidden"
              onClick={() => openModal(video)}
            >
              <img
                src={video.preview}
                alt={video.name}
                className="w-full object-cover aspect-video"
              />
              <div className="p-4">
                <h3 className="text-lg md:text-2xl font-lack">{video.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedVideo && (
  <div 
    onClick={closeModal}
    className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex justify-center items-center z-50 overflow-y-auto"
  >
    <div 
      className="z-20 bg-white rounded-lg p-4 md:p-8 relative w-[90%] max-w-4xl mx-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="absolute top-2 right-2 text-2xl md:text-xl font-bold text-gray-700 hover:text-black"
        onClick={closeModal}
      >
        &times;
      </button>
      <div className="relative pt-[56.25%]">
        <iframe
          width="100%"
          height="100%"
          className="absolute top-0 left-0 w-full h-full"
          src={selectedVideo.link}
          title={selectedVideo.name}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </div>
)}

      <Footer />
    </section>
  );
};

